import { QueryClient } from '@tanstack/react-query';

const QueryClientFactory = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // Don't refetch on focus for dev environments, having the latest data isn't that important
        refetchOnWindowFocus: !import.meta.env.DEV
      }
    }
  });

export const queryClient = QueryClientFactory();
